"use client";

import { useState, useMemo } from "react";
import { Play } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function VideoGalleryConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  const [selectedVideo, setSelectedVideo] = useState<{
    url: string;
    title: string;
  } | null>(null);
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(9)].map((_, i) => <div key={i} data-index={i} className="aspect-video rounded-lg bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-white">
        Failed to load videos.
      </div>;
  }
  if (posts.length === 0) {
    return <p className="text-center text-white">No videos to display.</p>;
  }
  return <>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post, i) => {
        const videoUrl = post.customFields?.url || "";
        const thumbnailUrl = post.customFields?.thumbnail || post.featuredImage || "";
        const videoTitle = post.customFields?.title || post.title || "Video";
        return <Button key={post.id} data-index={i} onClick={() => setSelectedVideo({
          url: videoUrl,
          title: videoTitle
        })} className="group relative aspect-video overflow-hidden rounded-lg bg-muted/20 focus-ring transition-all duration-200 p-0 h-auto border-0">
              {thumbnailUrl ? <img src={thumbnailUrl} alt={videoTitle} className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-102" /> : <div className="flex h-full w-full items-center justify-center bg-muted/30">
                  <span className="text-sm text-white">
                    No thumbnail
                  </span>
                </div>}
              <div className="absolute inset-0 flex items-center justify-center bg-background/60 opacity-0 backdrop-blur-sm transition-opacity duration-200 group-hover:opacity-100">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-dark text-foreground-accent shadow-medium">
                  <Play className="h-6 w-6" />
                </div>
              </div>
            </Button>;
      })}
        </div>

        <Dialog open={!!selectedVideo} onOpenChange={open => !open && setSelectedVideo(null)}>
          <DialogContent className="max-w-4xl p-0 animate-in slide-in-from-top-8 duration-200">
            <DialogTitle className="sr-only">
              {selectedVideo?.title || "Video"}
            </DialogTitle>
            {selectedVideo && <div className="aspect-video w-full overflow-hidden rounded-lg">
                <iframe src={selectedVideo.url} title={selectedVideo.title} className="h-full w-full" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
              </div>}
          </DialogContent>
        </Dialog>
      </>;
}
export default function ClientVideos() {
  const wp_query = useMemo(() => new WP_Query({
    post_type: "video",
    per_page: 12
  }), []);
  return;
}